var GARDENCREEK = GARDENCREEK || {};

GARDENCREEK.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

GARDENCREEK.navvy = function() {
	$('#gcSiteNav').on('hide.bs.collapse', function () {
		$('body').removeClass('navopen');
		$('.navbar-toggler').removeClass('navopen');
	});
	$('#gcSiteNav').on('show.bs.collapse', function () {
		$('.navbar-toggler').addClass('navopen');
		$('body').addClass('navopen');
	});
}();
GARDENCREEK.gutters = function() {
    var windowHeight = $(window).height();
	var elm_class = '.gutter';
	var trigger = '.trigger';
	$(window).scroll(function(){
		if ($(this).scrollTop() > windowHeight/2) { 
			$(elm_class).fadeIn();
		} else {
			$(elm_class).fadeOut();
		}
	});
	
	$(trigger).click(function(){
		$('html, body').animate({scrollTop : 0},windowHeight/2);
		return false;
	});
}();

GARDENCREEK.fader = function() {
	$(window).scroll(function(event){
		if($('body').hasClass('page-pages-wines')) {
			if ($('.warnelius-miller').is(':in-viewport(140)')) {
				$('body').addClass('page-warneliusmiller');
			} else {
				$('body').removeClass('page-warneliusmiller');	
			}
		}
	});	
}();
